import { z } from "zod";

import { zSchema } from "../../../../entity";

import type { OperationalErrorOptions } from "~/shared/error";
import { OperationalError } from "~/shared/error";

const zIn = zSchema
  .pick({
    id: true,
  })
  .extend({
    roles: z.array(
      zSchema.shape.roles.element.pick({
        id: true,
      }),
    ),
  });
type In = z.infer<typeof zIn>;

const zErrorReason = z.enum(["USER_NOT_FOUND", "ROLE_S_NOT_FOUND"]);
const ErrorReason = zErrorReason.Enum;
type ErrorReason = z.infer<typeof zErrorReason>;

class Error extends OperationalError {
  readonly reason: ErrorReason;

  constructor(reason: ErrorReason, options?: OperationalErrorOptions) {
    super(options);
    this.reason = reason;
    this.message = `Failed to assign roles to user.`;
  }
}

export { Error, ErrorReason, zErrorReason, zIn };
export type { In };
